import { Component, Vue } from 'vue-property-decorator';
import { Spinner } from '@/components/app';
import IAuthService from './services/auth/IAuthService';
import IUserContextService from './services/http/interfaces/IUserContextService';

@Component({
  components: {
    Spinner,
  },
})
export default class App extends Vue {
  appLoaded: boolean = false;
  isError: boolean = false;

  async created() {
    try {
      await this.saveUserToStore();
      this.appLoaded = true;
    } catch (e) {
      this.isError = true;
    }
  }

  async saveUserToStore() {
    const authService: IAuthService = this.$factory.createAuthService();
    const userContextService: IUserContextService = this.$factory.createUserContextService();

    // Persist current user (if they are logged in) to the Vuex store
    if (authService.isAuthenticated()) {
      await userContextService.getCurrentContext(authService.getAuthenticatedUser());
    }
  }

}
